import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const tooltipStaticStyle = css({
    borderRadius: tokens.borderRadius.medium,
    maxWidth: '300px',
    padding: `${tokens.spacingNew.xsmall} ${tokens.spacingNew.small}`,
    position: 'absolute',
    zIndex: 10,
});
export function tooltipStyle({ inverted, x, y }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        tooltipStaticStyle,
        css({
            backgroundColor: theme.background.contrastInverse,
            color: theme.text.inverse,
            left: x !== null && x !== void 0 ? x : 0,
            top: y !== null && y !== void 0 ? y : 0,
        }),
    ];
}
